import { Box, Typography } from "@mui/material";

const CacheManagementHeader = () => (
  <Box sx={{ mb: 3 }}>
    <Typography variant="h4" sx={{ fontWeight: 700, mb: 1 }}>
      Cache Management
    </Typography>
    <Typography variant="body2" color="text.secondary">
      Warm the cache, browse cached keys grouped by tag, and purge individual
      keys, whole tags, or the entire cache. Keys are tracked per server
      instance, so this is an approximate view of what is currently cached.
    </Typography>
  </Box>
);

export default CacheManagementHeader;
